import React, { useRef } from 'react'
import { ExternalLink } from 'lucide-react'
import { FloatingPanel, FloatingPanelHeaderIcon } from './ui-primitives/floating-panel'
import { YasguiEditor, type YasguiEditorHandle } from './YasguiEditor'
import { Sparql } from '../icons/sparql'

export function SparqlPopup(props: {
  onClose: () => void
  repoURL: string
  repoName: string
  localRepoURL?: string
}) {
  const editorRef = useRef<YasguiEditorHandle>(null)

  const popOutToWindow = () => {
    const params = new URLSearchParams({ repo: props.repoURL, repoName: props.repoName })
    if (props.localRepoURL) params.set('localRepo', props.localRepoURL)
    const query = editorRef.current?.getCurrentQuery()
    if (query) params.set('query', query)
    window.open(
      `/tools/sparql?${params}`,
      '_blank',
      'width=1000,height=700,popup,toolbar=no,menubar=no,status=no,scrollbars=yes'
    )
    props.onClose()
  }

  return (
    <FloatingPanel
      title="SPARQL"
      onClose={props.onClose}
      defaultSize={{ width: 800, height: 600 }}
      minSize={{ width: 500, height: 350 }}
      icon={Sparql}
      extraHeaderIcons={
        <FloatingPanelHeaderIcon
          title="Open in new window"
          icon={ExternalLink}
          onClick={popOutToWindow}
        />
      }
    >
      <YasguiEditor
        ref={editorRef}
        repoURL={props.repoURL}
        repoName={props.repoName}
        localRepoURL={props.localRepoURL}
        id="sparql-popup-yasgui"
      />
    </FloatingPanel>
  )
}